import { string } from 'yup'
import { safify } from '../utils/safify'

export const callToAction = string()
  .default('')
  .meta({
    label: 'Call to action',
    mobilePlaceholder: 'What should the reader do next',
    placeholder: 'What should the reader think, feel or do next',
    snippets: true,
    autoFill: true,
  })
  .transform(safify)
